var _path, _rect, _rect2, _rect3, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAcl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#798EBB",
    d: "M0 0h24v24H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 6.43,
    width: 8.333,
    height: 1.042,
    rx: 0.521,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 7.75,
    y: 8.93,
    width: 8.333,
    height: 1.042,
    rx: 0.521,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.75,
    y: 11.43,
    width: 4.167,
    height: 1.042,
    rx: 0.521,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.37 14.434v-.938c0-1.202-1.029-2.166-2.287-2.166s-2.287.964-2.287 2.165v.939c-.407.046-.73.375-.73.782v3.443c0 .44.377.788.83.788h4.375c.452 0 .829-.348.829-.788v-3.443c0-.407-.323-.736-.73-.782zm-3.645-.938c0-.7.603-1.277 1.358-1.277.756 0 1.359.577 1.359 1.277v.932h-2.717v-.933zm3.446 5.062h-4.175v-3.242h4.175v3.242z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.298 17.923h-5.01V4.937h10.93v5.28a.525.525 0 0 0 1.049 0V4.418a.527.527 0 0 0-.525-.519H5.763a.527.527 0 0 0-.525.519v14.005c0 .284.241.519.525.519h5.535a.51.51 0 0 0 0-1.02z",
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.5,
    y1: 9.5,
    x2: 17.5,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.752,
    y1: 4,
    x2: 11.752,
    y2: 35.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcl);
export default __webpack_public_path__ + "static/media/icon-acl.33e3993984b52b69163ddaea1b81cff0.svg";
export { ForwardRef as ReactComponent };